import ManagedGridView from "../controls/ManagedGridView";
import { SearchQuery } from "../code/search-query/search-query";
import {
  permissionTypesViewColumns,
  permissionTypesSearchSchema,
  mapPermissionTypesViewQuery,
} from "./PermissionTypesView.default";
import { getPermissions } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";

export interface PermissionTypesViewProps {
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function PermissionTypesView(props: PermissionTypesViewProps) {
  return (
    <ManagedGridView
      columns={permissionTypesViewColumns}
      schema={permissionTypesSearchSchema}
      mapQuery={mapPermissionTypesViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getPermissions, { retry: true })}
      pageSize={100}
    />
  );
}

export default PermissionTypesView;
